import axiosInstance from './axios-instance';

export const submitArticleOpinion = async (data: { articleId: string; type: string }) => {
  const result = await axiosInstance.post(`/api/v1/publisher/articles/article-opinions`, data);
  return result.data;
};

export const getArticleOpinionStats = async (articleId: string) => {
  const result = await axiosInstance.get(
    `/api/v1/publisher/articles/article-opinions/article/${articleId}`
  );
  return result.data;
};

export const getUserArticleOpinion = async (articleId: string) => {
  const result = await axiosInstance.get(
    `/api/v1/publisher/articles/article-opinions/article/${articleId}/user`
  );
  return result.data;
};
